import React from "react";
import GlobalNav from "../components/GlobalNav";
import Footer from "../components/Footer";
import "./PrivacyPage.css";

// Legal text preserved faithfully from the org's original privacy.handlebars
// page — not paraphrased, since privacy policies need to remain a precise,
// accurate statement of actual practice, not a rewritten approximation.
export default function PrivacyPage() {
  return (
    <div className="privacy-page">
      <GlobalNav activeHref="/privacy" ctaLabel="Join the collective" />

      <div className="privacy-body">
        <h1>Privacy Policy</h1>

        <p>
          Music Is Healing does not collect personal data from visitors to the
          website who order products. However we use web statistics tools and
          track IP addresses so we can improve our services and enhance your
          online experience. MusicIsHealing.Us does not collect personally
          identifiable information from anyone. If you are under sixteen,
          please ask your parents to order for you. Please do not submit any
          personal details if you are under eighteen.
        </p>

        <h2>How MusicIsHealing.Us uses information you provide</h2>
        <p>
          If you give us your personal information, we will use this
          information to send your products. We will send you announcements
          or communications by email in regard to your order. Otherwise, we
          use your information only to review our performance and to improve
          our services to you.
        </p>

        <h2>Does MusicIsHealing.Us share your information with others?</h2>
        <p>
          MusicIsHealing.Us does not sell, rent or disclose our client's
          names, addresses, email addresses or other personal information to
          any entity. MusicIsHealing.Us may share client information within
          the organization, including other commonly-owned brands, so that
          you may be informed of other products that may be of interest to
          you. Further, in order to maintain our website and provide our
          client communications, MusicIsHealing.Us contracts with selected
          third party developers. Your personal information will not be
          processed by these third parties beyond what is necessary for
          assisting MusicIsHealing.Us in these endeavors, and such
          arrangements are subject to strict contractual confidentiality
          obligations. We do not disclose your information to third parties,
          unless required by law or in connection with a legal claim or
          proceeding. If MusicIsHealing.Us is acquired by another entity,
          information about MusicIsHealing.Us clients may be made available
          to the new entity.
        </p>

        <h2>About security</h2>
        <p>
          MusicIsHealing.Us uses appropriate security measures to protect the
          information you give us. However, while we take all reasonable
          steps to protect your personal information, you accept that no
          Internet data transmission can be guaranteed to be secure from
          access by unintended recipients and will not hold us responsible
          for any breach of security unless this is due to our negligence.
        </p>

        <h2>About cookies</h2>
        <p>
          Cookies are pieces of information a web site can send to your
          computer's browser for record-keeping purposes. MusicIsHealing.Us
          uses cookies to assess which web pages are visited and how often,
          to make our web site more user friendly, and to give you a better
          experience when you return to the website. Most web browsers
          automatically accept cookies, but you do not have to accept them.
          To disable cookies, you should access the "help" tab on your
          browser or read the information that came with your browser
          software.
        </p>

        <h2>Acceptance of privacy policy and modifications</h2>
        <p>
          By accessing and using the MusicIsHealing.Us website, you consent
          to our collection, use and non-disclosure of your information as
          described in this privacy policy. MusicIsHealing.Us reserves the
          right occasionally to make changes to its privacy policy or
          practices. You should therefore review this page from time to time
          to get updated information. We will notify you of any changes in
          our privacy policy by posting the modifications on our website.
        </p>

        <p className="privacy-signed">SIGNED<br />MIHU</p>
      </div>

      <Footer />
    </div>
  );
}
